import Banner from '../components/Banner.js';
import BulkDealsSection from '../components/BulkDealsSection.js';
import Form from '../components/Form.js'

const BulkDeal = () => {
    return (
        <>
        <div  style={{ background: "linear-gradient(to right, #fff8f0, #f5f5f5)" }}>
            <Banner
                image="https://www.jpoint.in/assets/assets/images/bulk-d-img.png"
                heading="Bulk Deals"
            />
            <BulkDealsSection />
            <div className='d-block d-md-flex'>
                <div className='w-100 w-md-50'> <Form /></div>

                <div className='w-100 w-md-50 h-full d-flex'>
                    <div className="d-flex flex-column align-items-center justify-content-around rounded-4 p-4 h-full">
                        <div className="col-md-12 text-center text-md-start mb-4 mb-md-0">
                            <h2 className="fw-bold display-5 fs-3">Bulk Deals</h2>
                            <p className="lead mt-3">
                                Take advantage of our exclusive bulk deals to get the best value for large orders.
                                Perfect for events, corporate programs, or group gifting needs.
                            </p>
                            <p className="lead mt-3">
                                From premium products to customized packages, we ensure quality and efficiency
                                at scale, making bulk purchasing simple and cost-effective.
                            </p>
                            <p className="lead mt-3">
                                Partner with us for bulk orders and enjoy special pricing, tailored solutions,
                                and seamless delivery for all your large-scale requirements.
                            </p>
                        </div>
                    </div>

                </div>
            </div>
            </div>
        </>
    )
}

export default BulkDeal;